<template>
  <b-card class="rounded-xl border-none" no-body>
    <div v-if="!isShowCreate">
      <div class="flex justify-end">
        <base-button
          outline
          type="success"
          class="flex"
          @click="isShowCreate = true"
        >
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Create New
          E-mail Template
        </base-button>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="CategoryData"
      >
        <el-table-column label="Sl. No." min-width="120px" prop="sno" sortable>
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.sno }}</span>
          </template>
        </el-table-column>

        <el-table-column label=" ID" min-width="120px" prop="id" sortable>
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Image" min-width="140px" prop="image" sortable>
          <img
            src="../../img/temp1.png"
            class="w-full h-85px object-cover rounded-lg"
            alt="image"
          />
        </el-table-column>

        <el-table-column label="Video" min-width="140px" prop="video" sortable>
          <video class="w-full h-85px rounded-lg" controls>
            <source src="../../img/dummyvideo.mp4" type="video/mp4" />
          </video>
        </el-table-column>

        <el-table-column
          label="Created Date	"
          min-width="140px"
          prop="createdate"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black font-medium">{{ row.createdate }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Action"
          min-width="100px"
          prop="action"
          sortable
        >
          <template>
            <div class="flex items-center">
              <div class="flex items-center cursor-pointer">
                <feather-icon
                  icon="Trash2Icon"
                  svgClasses="w-5"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Delete"
                ></feather-icon>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="50"
        ></base-pagination>
      </b-card-footer>
    </div>

    <div v-show="isShowCreate">
      <CreateNewEmailTemplate />
    </div>
  </b-card>
</template>
<script>
import CreateNewEmailTemplate from "./CreateNewEmailTemplate";
import CategoryData from "./CategoryData";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,

    CreateNewEmailTemplate,
  },
  data() {
    return {
      CategoryData,
      currentPage: 1,
      editModal: false,
      isShowCreate: false,
    };
  },
};
</script>
